import CollapsibleCardContext from "components/shared/components/CollapsibleCard/context/CollapsibleCardContext";
import { useContext } from "react";

export const useCollapsibleCard = () => {
  const ctx = useContext(CollapsibleCardContext);
  if (!ctx) {
    throw new Error("useCollapsibleCard must be used within a CollapsibleCardProvider");
  }
  return ctx;
};
